exports.GROUP3 = [{ g3id: 'richard', g3title: 'richard' }]
